import { c as _c } from "react/compiler-runtime";
import { Box, Typography } from '@mui/material';
import Image from 'next/image';
export const BalanceTransferCalculatorError = () => {
  const $ = _c(3);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      paddingX: {
        xs: 3,
        sm: 4
      },
      paddingY: 4
    };
    t1 = <Image src="https://cdns3.nerdwallet.com/cc-shopping-client/bt-calculator/binoculars_question_mark.png" height={109} width={132} alt="" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Box sx={t0}>{t1}<Typography sx={{
        marginTop: 4,
        textAlign: "center"
      }}>Looks like this balance transfer wouldn’t save you any money. Keep your debt where it is an pay it off as soon as you can.</Typography></Box>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};